import { render, staticRenderFns } from "./MenuEditor.vue?vue&type=template&id=be65c1f8&scoped=true&"
import script from "./MenuEditor.vue?vue&type=script&lang=ts&"
export * from "./MenuEditor.vue?vue&type=script&lang=ts&"
import style0 from "./MenuEditor.vue?vue&type=style&index=0&id=be65c1f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be65c1f8",
  null
  
)

export default component.exports